export default "__VITE_ASSET__C7AhdjoW__"